import { vsingleton } from './decorators'
import { Facade } from './helpers'
import Vue from 'vue'

@vsingleton()
class ConfigService {
  private readonly configs: Record<string, any>

  constructor() {
    this.configs = Vue.observable({})
  }

  get(name: string) {
    return this.configs[name]
  }

  set(name: string, value: any) {
    return Vue.set(this.configs, name, value)
  }

  delete(name: string) {
    return Vue.delete(this.configs, name)
  }
}

export class Config extends Facade<ConfigService>() {
  static getFacadeAccessor() {
    return ConfigService
  }
}
